import { useState, useEffect } from "react";
import { TextField, Button, MenuItem, InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import SearchIcon from "@mui/icons-material/Search";
import ActionButtons from "../components/common/ActionButtons";

import {
    addCallLog,
    updateCallLog,
    deleteCallLog,
    getCallLogs
} from "../services/employeeCallLogService";

import { getEmployees } from "../services/employeeService";
import { getCustomers } from "../services/customerService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import usePagination from "../hooks/usePagination";
import PaginationControls from "../components/common/PaginationControls";
import { addCustomer } from "../services/customerService";
import DateCell from "../components/common/DateCell";

function DailyCall() {
    const getTodayDate = () =>
        new Date().toLocaleDateString("en-CA");
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const userRole = (loggedInUser?.role || "").toLowerCase();
    console.log("ROLE =", userRole);

    const loggedEmployeeId = loggedInUser?.empId || "";
    const loggedBranchId = loggedInUser?.branchId || "";

    const allBranches =
        (loggedInUser?.allBranches || "N") === "Y";

    const branchManager =
        (loggedInUser?.branchManager || "N") === "Y";

    const isAdmin =
        userRole === "admin";

    const isManager =
        userRole === "manager";

    const isUser =
        userRole === "user";

    const [form, setForm] = useState({
        employeeId: "",
        employeeLocation: "",
        createdOn: getTodayDate(),
        organizationName: "",
        customerName: "",
        contactNumber: "",
        emailAddress: "",          // ✅ FIXED
        customerType: "",
        callType: "Marketing",
        potentialValue: "",
        requirementOrModelSuggested: "",
        nextFollowUpDate: "",      // ✅ FIXED
        remarks: "",
        status: "Active"
    });

    const [employees, setEmployees] = useState([]);
    const loggedEmployeeName =
        employees.find(
            e => Number(e.id) === Number(loggedEmployeeId)
        )?.empName || "";
    const [customers, setCustomers] = useState([]);

    // ✅ MAIN DATA
    const [callLogs, setCallLogs] = useState([]);

    // ✅ FILTER STATES (KEEP ONLY THESE)
    const [showInactive, setShowInactive] = useState(false);
    const [searchText, setSearchText] = useState("");
    const today = new Date();

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    const [fromDate, setFromDate] = useState(
        sevenDaysAgo.toISOString().split("T")[0]
    );

    const [toDate, setToDate] = useState(
        today.toISOString().split("T")[0]
    );
    const [sortField, setSortField] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDirection("asc");
        }
    };

    const handleLast7Days = () => {

        const today = new Date();

        const sevenDaysAgo = new Date();

        sevenDaysAgo.setDate(today.getDate() - 7);

        setFromDate(
            sevenDaysAgo.toISOString().split("T")[0]
        );

        setToDate(
            today.toISOString().split("T")[0]
        );
    };

    // ✅ ALL STATES FIRST
    const [rowsPerPage, setRowsPerPage] = useState(10);

    console.log("LOGGED USER:", loggedEmployeeName);

    console.log("CALL LOG EMPLOYEES:",
        callLogs.map(x => x.employeeName)
    );

    // ✅ FILTER LOGIC
    const filteredData = (callLogs || [])

        // USER
        .filter(c => {

            // ADMIN + AllBranches=Y
            if (isAdmin && allBranches) {
                return true;
            }

            // ADMIN + AllBranches=N
            if (isAdmin && !allBranches) {

                return employees.some(
                    e =>
                        (e.empName || "").trim().toLowerCase() ===
                        (c.employeeName || "").trim().toLowerCase()
                        &&
                        e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=Y
            if (isManager && branchManager) {

                return employees.some(
                    e =>
                        (e.empName || "").trim().toLowerCase() ===
                        (c.employeeName || "").trim().toLowerCase()
                        &&
                        e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=N
            if (isManager && !branchManager) {

                return (
                    (c.employeeName || "").trim().toLowerCase() ===
                    (loggedEmployeeName || "").trim().toLowerCase()
                );
            }

            // USER
            if (isUser) {

                return (
                    (c.employeeName || "").trim().toLowerCase() ===
                    (loggedEmployeeName || "").trim().toLowerCase()
                );
            }

            return false;
        })

        .filter(c => showInactive ? true : c.status !== "Inactive")

        .filter(c => {

            if (!c.createdOn) return false;

            const createdDate =
                new Date(c.createdOn).toISOString().split("T")[0];

            return (
                createdDate >= fromDate &&
                createdDate <= toDate
            );
        })

        .filter(c => {

            const search = searchText.toLowerCase();

            return (
                (c.customerName || "").toLowerCase().includes(search) ||

                (c.employeeName || "").toLowerCase().includes(search) ||

                (c.organizationName || "").toLowerCase().includes(search) ||

                (c.contactNumber || "").toLowerCase().includes(search) ||

                (c.callType || "").toLowerCase().includes(search) ||

                (c.status || "").toLowerCase().includes(search) ||

                (new Date(c.nextFollowUpDate)
                    .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    })
                    .toLowerCase()
                    .includes(search)) ||

                (Number(c.potentialValue || 0)
                    .toFixed(2)
                    .toLowerCase()
                    .includes(search))
            );
        })

        .sort((a, b) => {

            if (!sortField) return 0;

            let valA = a[sortField] || "";
            let valB = b[sortField] || "";

            if (typeof valA === "string") valA = valA.toLowerCase();
            if (typeof valB === "string") valB = valB.toLowerCase();

            if (valA < valB)
                return sortDirection === "asc" ? -1 : 1;

            if (valA > valB)
                return sortDirection === "asc" ? 1 : -1;

            return 0;
        });

    useEffect(() => {
        loadEmployees();
        loadCustomers();
    }, []);

    useEffect(() => {

        if (employees.length > 0) {

            loadCallLogs();

        }

    }, [employees]);

    useEffect(() => {

        // USER ROLE
        if (userRole === "user") {

            setForm(prev => ({
                ...prev,
                employeeId: Number(loggedEmployeeId),
                employeeName: loggedEmployeeName
            }));
        }

    }, [userRole, loggedEmployeeId, loggedEmployeeName]);

    const {
        page,
        setPage,
        totalPages,
        paginatedData
    } = usePagination(filteredData, rowsPerPage);

    useEffect(() => {
        setPage(0);
    }, [searchText, showInactive, rowsPerPage]);

    const loadEmployees = async () => {
        try {

            const res = await getEmployees();

            let data = res.data || [];

            // USER → only himself
            // ADMIN + AllBranches=Y
            if (isAdmin && allBranches) {

                // show all employees
            }

            // ADMIN + AllBranches=N
            else if (isAdmin && !allBranches) {

                data = data.filter(
                    e => e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=Y
            else if (isManager && branchManager) {

                data = data.filter(
                    e => e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=N
            else if (isManager && !branchManager) {

                data = data.filter(
                    e => e.id === loggedEmployeeId
                );
            }

            // USER
            else if (isUser) {

                data = data.filter(
                    e => e.id === loggedEmployeeId
                );
            }

            setEmployees(data);

        } catch (err) {
            console.error("Failed to load employees", err);
        }
    };

    const loadCustomers = async () => {
        try {
            const res = await getCustomers();
            setCustomers(res.data);
        } catch (err) {
            console.error("Failed to load customers", err);
        }
    };

    const loadCallLogs = async () => {
        try {
            const res = await getCallLogs();
            console.log("API DATA:", res.data);   // 🔥 ADD THIS
            console.log(
                res.data.filter(
                    x => x.employeeName?.toLowerCase() === "admin"
                )
            );
            const enrichedData = (res.data || []).map(call => {

                const emp = employees.find(
                    e => Number(e.id) === Number(call.employeeId)
                );

                return {

                    ...call,

                    employeeName:
                        emp?.empName || call.employeeName,

                    empCode:
                        emp?.empCode || "",

                    branchName:
                        emp?.branchName || ""

                };
            });

            setCallLogs(enrichedData);
        } catch (err) {
            console.error("Failed to load call logs", err);
        }
    };
    const [isEdit, setIsEdit] = useState(false);

 
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "potentialValue") {
            if (!/^\d*\.?\d{0,2}$/.test(value)) return;
        }
        // ✅ SPECIAL HANDLING FOR DATE
        if (name === "nextFollowUpDate") {
            setForm(prev => ({
                ...prev,
                nextFollowUpDate: value // already in YYYY-MM-DD
            }));
            return;
        }

        setForm(prev => ({
            ...prev,
            [name]: value   // 🔥 REMOVE null conversion
        }));
    };

    // 🔥 NEW FUNCTION (IMPORTANT)
    const handleEmployeeChange = (e) => {
        const empId = e.target.value;

        const selectedEmp = employees.find(emp => emp.id === Number(empId));

        setForm(prev => ({
            ...prev,
            employeeId: empId,
            employeeName: selectedEmp?.empName || ""   // 🔥 ADD THIS LINE
        }));
    };

    const handleCustomerChange = (e) => {
        const id = e.target.value;

        const selected = customers.find(c => c.id === id);

        if (!selected) return;

        setForm(prev => ({
            ...prev,
            customerId: id,
            organizationName: selected.organizationName,
            customerName: selected.customerName,
            contactNumber: selected.contactNumber,
            emailAddress: selected.emailAddress,
            customerType: selected.customerType
        }));
    };

    const handleOrganizationChange = (e) => {
        const value = e.target.value;

        // 🔍 exact match only (NOT startsWith)
        const exactMatch = customers.find(c =>
            (c.organizationName || "").toLowerCase().trim() === value.toLowerCase().trim()
        );

        if (exactMatch) {
            // ✅ AUTO-FILL ONLY WHEN EXACT MATCH
            setForm(prev => ({
                ...prev,
                organizationName: value,
                customerName: exactMatch.custName || "",
                contactNumber: exactMatch.mobileNo || "",
                emailAddress: exactMatch.emailId || "",
                customerType: exactMatch.customerType || ""
            }));
        } else {
            // ✅ USER IS TYPING / EDITING → DO NOT OVERRIDE
            setForm(prev => ({
                ...prev,
                organizationName: value,
                customerName: "",
                contactNumber: "",
                emailAddress: "",
                customerType: ""
            }));
        }
    };

    const handleBlur = (e) => {
        if (e.target.name === "potentialValue") {
            let value = e.target.value;

            if (value === "") return;

            const formatted = parseFloat(value).toFixed(2);

            setForm(prev => ({
                ...prev,
                potentialValue: formatted
            }));
        }
    };

    const highlightText = (text) => {

        if (!searchText) return text;

        const regex = new RegExp(`(${searchText})`, "gi");

        const parts = String(text || "").split(regex);

        return parts.map((part, index) =>

            part.toLowerCase() === searchText.toLowerCase()

                ? (
                    <span
                        key={index}
                        style={{
                            backgroundColor: "yellow",
                            fontWeight: "bold",
                            padding: "0 2px"
                        }}
                    >
                        {part}
                    </span>
                )

                : part
        );
    };

    const handleSave = async () => {
        try {
            console.log("SAVE CLICKED");

            // ✅ DIRECT PAYLOAD (NO CUSTOMER INSERT LOGIC)
            const payload = {
                employeeId: form.employeeId,
                employeeName: form.employeeName,
                createdOn: form.createdOn || getTodayDate(),
                customerName: form.customerName,
                organizationName: form.organizationName,
                contactNumber: form.contactNumber,

                // ✅ FIX 1 (IMPORTANT)
                emailAddress: form.emailAddress ? form.emailAddress : null,

                location: form.employeeLocation,
                customerType: form.customerType,
                callType: form.callType,

                // ✅ FIX 2
                potentialValue: form.potentialValue ? Number(form.potentialValue) : null,

                requirementOrModelSuggested: form.requirementOrModelSuggested,

                // ✅ FIX 3 (VERY IMPORTANT)
                nextFollowUpDate: form.nextFollowUpDate || null,

                remarks: form.remarks,
                status: form.status
            };

            console.log("Payload:", payload);
            console.log("FINAL PAYLOAD:", JSON.stringify(payload));
            let res;

            if (form.id) {
                // ✅ UPDATE
                res = await updateCallLog(form.id, {
                    ...payload,
                    id: form.id
                });
            } else {
                // ✅ CREATE
                res = await addCallLog(payload);
            }

            console.log("Response:", res.data);

            alert(form.id ? "Updated successfully" : "Saved successfully");

            // ✅ AUDIT
            const label = `${form.customerName} - ${form.organizationName}`;

            // ✅ REFRESH DATA
            loadCallLogs();

            // ✅ RESET FORM
            setForm({
                employeeId:
                    userRole === "user"
                        ? loggedEmployeeId
                        : "",

                employeeName:
                    userRole === "user"
                        ? loggedEmployeeName
                        : "",        // 🔥 IMPORTANT RESET
                employeeLocation: "",
                createdOn: getTodayDate(),
                organizationName: "",
                customerName: "",
                contactNumber: "",
                emailAddress: "",
                customerType: "",
                callType: "Marketing",
                potentialValue: "",
                requirementOrModelSuggested: "",
                nextFollowUpDate: "",
                remarks: "",
                status: "Active"
            });

            setIsEdit(false);

        } catch (err) {
            console.error("FULL ERROR:", err);
            console.error("BACKEND ERROR:", err.response?.data);
            console.log("FORM ID:", form.id);
            alert(err.response?.data || "Error saving data");
        }
    };

    const handleEdit = (row) => {

        setForm({
            id: row.id,

            employeeId: row.employeeId || "",
            employeeName: row.employeeName || "",

            employeeLocation: row.location || "",
            createdOn:
                row.createdOn
                    ? row.createdOn.split("T")[0]
                    : getTodayDate(),
            organizationName: row.organizationName || "",
            customerName: row.customerName || "",
            contactNumber: row.contactNumber || "",
            emailAddress: row.emailAddress || "",
            customerType: row.customerType || "",
            callType: row.callType || "Marketing",
            potentialValue: row.potentialValue || "",
            requirementOrModelSuggested: row.requirementOrModelSuggested || "",
            nextFollowUpDate:
                row.nextFollowUpDate
                    ? row.nextFollowUpDate.split("T")[0]
                    : "",
            remarks: row.remarks || "",
            status: row.status || "Active"
        });

        setIsEdit(true);
    };

    const handleDelete = async (row) => {
        if (!window.confirm("Deactivate this record?")) return;

        try {
            const payload = {
                id: row.id,
                employeeId: row.employeeId,
                employeeName: row.employeeName,
                customerName: row.customerName,
                organizationName: row.organizationName,
                contactNumber: row.contactNumber,
                emailAddress: row.emailAddress,
                location: row.location,
                customerType: row.customerType,
                callType: row.callType,
                potentialValue: row.potentialValue || 0,
                requirementOrModelSuggested: row.requirementOrModelSuggested,
                nextFollowUpDate: row.nextFollowUpDate,
                remarks: row.remarks,
                status: "Inactive"
            };

            await updateCallLog(row.id, payload);

            // ✅ AUDIT
            const label = `${row.customerName} - ${row.organizationName}`;

            loadCallLogs();

        } catch (err) {
            console.error("Delete failed:", err);
        }
    };

    const handlePermanentDelete = async (row) => {
        if (!window.confirm("Delete permanently?")) return;

        try {
            await deleteCallLog(row.id);

            // ✅ AUDIT (FIXED MESSAGE)
            const label = `${row.customerName} - ${row.organizationName}`;

            loadCallLogs();

        } catch (err) {

            console.log("FULL ERROR", err);

            console.log(
                "BACKEND ERROR",
                err.response?.data
            );

            console.log(
                "STATUS",
                err.response?.status
            );

            alert(
                JSON.stringify(
                    err.response?.data || err.message
                )
            );

        }
    };

    const handleRestore = async (row) => {
        try {
            if (!window.confirm("Restore this record?")) return;

            const payload = {
                id: row.id,
                employeeId: row.employeeId,
                employeeName: row.employeeName,
                customerName: row.customerName,
                organizationName: row.organizationName,
                contactNumber: row.contactNumber,
                emailAddress: row.emailAddress,
                location: row.location,
                customerType: row.customerType,
                callType: row.callType,
                potentialValue: row.potentialValue || 0,
                requirementOrModelSuggested: row.requirementOrModelSuggested,
                nextFollowUpDate: row.nextFollowUpDate,
                remarks: row.remarks,
                status: "Active"
            };

            await updateCallLog(row.id, payload);

            alert("Restored successfully");

            // ✅ AUDIT (FIXED)
            const label = `${row.customerName} - ${row.organizationName}`;

            loadCallLogs();

        } catch (err) {
            console.error("Restore error:", err);
            alert("Error restoring record");
        }
    };

    const handleCancel = () => {
        setForm({
            employeeId: "",
            employeeLocation: "",
            createdOn: getTodayDate(),
            organizationName: "",
            customerName: "",
            contactNumber: "",
            emailAddress: "",
            customerType: "",
            callType: "Marketing",
            potentialValue: "",
            requirementOrModelSuggested: "",
            nextFollowUpDate: "",
            remarks: "",
            status: "Active"
        });

        setIsEdit(false);
    };

    const handleExport = () => {
        try {
            if (!callLogs || callLogs.length === 0) {
                alert("No data to export");
                return;
            }

            const data = (callLogs || []).map(c => ({
                Id: c.id,
                EmployeeName: c.employeeName,
                CustomerName: c.customerName,
                OrganizationName: c.organizationName,
                ContactNumber: c.contactNumber,
                EmailAddress: c.emailAddress,
                Location: c.location,
                CustomerType: c.customerType,
                CallType: c.callType,
                PotentialValue: c.potentialValue,
                RequirementOrModelSuggested: c.requirementOrModelSuggested,
                NextFollowUpDate: c.nextFollowUpDate ? c.nextFollowUpDate.split("T")[0] : "",
                Remarks: c.remarks,
                CreatedOn: c.createdOn ? c.createdOn.split("T")[0] : "",
                UpdatedOn: c.updatedOn ? c.updatedOn.split("T")[0] : "",
                Status: c.status
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "DCR");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            saveAs(blob, "DCR_Full_Data.xlsx");

        } catch (err) {
            console.error("Export error:", err);
            alert("Error exporting Excel");
        }
    };

    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <h2>Daily Call Register</h2>
            </div>

            <div style={styles.card}>
                <div style={styles.formContainer}>

                    {/* ROW 1 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                select
                                label="Employee"
                                disabled={userRole === "user"}
                                name="employeeId"
                                value={form.employeeId}
                                onChange={handleEmployeeChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            >
                                {[...employees]

                                    .sort((a, b) =>
                                        a.empName.localeCompare(b.empName)
                                    )

                                    .map(emp => (

                                        <MenuItem
                                            key={emp.id}
                                            value={emp.id}
                                            sx={{
                                                fontFamily: "Verdana",
                                                fontSize: "12px"
                                            }}
                                        >
                                            <div style={{
                                                display: "flex",
                                                width: "100%",
                                                alignItems: "center"
                                            }}>

                                                {/* EMPLOYEE */}
                                                <span style={{
                                                    width: "160px",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis"
                                                }}>
                                                    {emp.empName}
                                                </span>

                                                {/* BRANCH */}
                                                <span style={{
                                                    width: "140px"
                                                }}>
                                                    {"-> "} {emp.branchName}
                                                </span>

                                                {/* MOBILE */}
                                                <span>
                                                    {"-> "} {emp.mobileNo}
                                                </span>

                                            </div>
                                        </MenuItem>

                                    ))}
                            </TextField>
                        </div>

                        <div style={{
                            width: "50%",
                            display: "flex",
                            gap: "10px"
                        }}>

                            <div style={{ width: "50%" }}>
                                <TextField
                                    label="Log Date"
                                    name="createdOn"
                                    type="date"
                                    value={form.createdOn || ""}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    sx={styles.inputStyle}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </div>

                            <div style={{ width: "50%" }}>
                                <TextField
                                    label="Location"
                                    name="employeeLocation"
                                    value={form.employeeLocation}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    sx={styles.inputStyle}
                                />
                            </div>

                        </div>
                    </div>

                    {/* ROW 2 */}
                    {/* ROW 2 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Organization Name"
                                name="organizationName"
                                value={form.organizationName}
                                onChange={handleOrganizationChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                inputProps={{ list: "org-list" }}   // 🔥 enables dropdown + typing
                            />

                            <datalist id="org-list">
                                {customers.map(c => (
                                    <option key={c.id} value={c.organizationName} />
                                ))}
                            </datalist>
                        </div>

                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Customer Name"
                                name="customerName"
                                value={form.customerName}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            />
                        </div>
                    </div>

                    {/* ROW 3 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Contact Number"
                                name="contactNumber"
                                value={form.contactNumber}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}   // 🔥 FIX
                            />
                        </div>

                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Email Address"
                                name="emailAddress"
                                value={form.emailAddress || ""}   // ✅ IMPORTANT
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}   // 🔥 FIX
                            />
                        </div>
                    </div>

                    {/* ROW 4 */}
                    <div style={styles.row}>
                        <div style={{ width: "25%" }}>
                            <TextField
                                select
                                label="Customer Type"
                                name="customerType"
                                value={form.customerType || ""}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}
                            >
                                <MenuItem value="Banking" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Banking
                                </MenuItem>

                                <MenuItem value="Non Banking" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Non Banking
                                </MenuItem>

                                <MenuItem value="Institutional" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Institutional
                                </MenuItem>
                            </TextField>
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                select
                                label="Call Type"
                                name="callType"
                                value={form.callType}   // 🔥 IMPORTANT
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}
                            >
                                <MenuItem value="Marketing" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Marketing
                                </MenuItem>

                                <MenuItem value="FollowUp" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Follow Up
                                </MenuItem>

                                <MenuItem value="Negotiation" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Negotiation
                                </MenuItem>

                                <MenuItem value="Collection" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Collection
                                </MenuItem>

                                <MenuItem value="Service" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Service
                                </MenuItem>
                                <MenuItem value="Sales" sx={{ fontFamily: "Verdana", fontSize: "12px" }}>
                                    Sales
                                </MenuItem>
                            </TextField>
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                label="Potential / Sales Value"
                                name="potentialValue"
                                type="number"
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                value={form.potentialValue}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{ step: "1", min: "0" }}
                            />
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                label="Next Followup Date"
                                name="nextFollowUpDate"   // ✅ FIXED (capital U)
                                type="date"
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                value={
                                    form.nextFollowUpDate
                                        ? form.nextFollowUpDate.substring(0, 10)
                                        : ""
                                }
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                    </div>

                    {/* ROW 5 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Requirement Model"
                                name="requirementOrModelSuggested"
                                value={form.requirementOrModelSuggested}
                                onChange={handleChange}
                                fullWidth
                                multiline
                                size="small"
                                rows={6}
                                sx={{
                                    ...styles.inputStyle,   // ✅ keep font
                                    "& .MuiInputBase-root": {
                                        height: "100px",    // ✅ keep your height
                                        alignItems: "flex-start"
                                    }
                                }}
                            />
                        </div>

                        {/* RIGHT SIDE */}
                        <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: "8px" }}>

                            {/* REMARKS */}
                            <TextField
                                label="Remarks"
                                name="remarks"
                                value={form.remarks}
                                onChange={handleChange}
                                fullWidth
                                multiline
                                size="small"
                                rows={4}
                                sx={{
                                    ...styles.inputStyle,   // ✅ keep font
                                    "& .MuiInputBase-root": {
                                        height: "60px",     // ✅ keep height
                                        alignItems: "flex-start"
                                    }
                                }}
                            />

                            {/* STATUS */}
                            <TextField
                                select
                                label="Status"
                                name="status"
                                value={form.status || ""}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                "& .MuiMenuItem-root": {
                                                    fontSize: "12px",
                                                    fontFamily: "Verdana"
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Closed">Closed</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                            </TextField>

                        </div>
                    </div>

                </div>

                <div style={styles.buttonRow}>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            //minWidth: "100px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            textTransform: "none"
                        }}
                    >
                        {isEdit ? "Update" : "Save"}
                    </Button>

                    {isEdit && (
                        <Button
                            variant="contained"
                            onClick={handleCancel}
                            sx={{
                                height: "28px",
                                //minWidth: "100px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                padding: "0 12px",
                                textTransform: "none",
                                backgroundColor: "#3a3f45",   // 🔥 dark grey like your pic
                                marginLeft: "10px",
                                "&:hover": {
                                    backgroundColor: "#2f343a"
                                }
                            }}
                        >
                            Cancel
                        </Button>
                    )}
                </div>

            </div>   {/* ✅ FORM CARD ENDS HERE */}


            {/* 🔥 🔥 PASTE TABLE HERE 🔥 🔥 */}
            <div style={styles.card}>

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "15px",
                    width: "100%",
                    flexWrap: "wrap" 
                }}>
                    {/* ✅ ADD THIS FIRST */}
                    <Button
                        variant="contained"
                        onClick={handleLast7Days}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            textTransform: "none",
                            background: "#57606f"
                        }}
                    >
                        Last 7 Days
                    </Button>

                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>

                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            style={{
                                height: "34px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 10px",
                                boxSizing: "border-box"
                            }}
                        />

                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            style={{
                                height: "34px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 10px",
                                boxSizing: "border-box"
                            }}
                        />

                        <Button
                            variant="contained"
                            sx={{
                                height: "28px",
                                minHeight: "28px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                padding: "0 12px",
                                textTransform: "none",
                                background: "#2f3542"
                            }}
                        >
                            Filter
                        </Button>

                    </div>

                    <label style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
                        <input
                            type="checkbox"
                            checked={showInactive}
                            onChange={(e) => setShowInactive(e.target.checked)}
                        />
                        Show Inactive
                    </label>

                    {/* 🔍 Search Box (FIXED) */}
                    <TextField
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        size="small"
                        sx={{
                            width: "220px",

                            "& .MuiOutlinedInput-root": {
                                height: "28px",
                                fontFamily: "Verdana"
                            },

                            "& .MuiOutlinedInput-input": {
                                padding: "4px 10px",
                                fontSize: "12px",
                                fontFamily: "Verdana"
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                            endAdornment: searchText && (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={() => setSearchText("")}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    {/* 📤 Export */}
                    <Button
                        variant="contained"
                        onClick={handleExport}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            background: "#3742fa"
                        }}
                    >
                        Export
                    </Button>

                    {/* 📄 Rows */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <span style={{ fontSize: "12px" }}>Rows</span>
                        <select
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(parseInt(e.target.value))}
                            style={{
                                height: "28px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 5px"
                            }}
                        >
                            {[5, 10, 20, 30, 50].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                    </div>

                </div>

                <div style={{ ...styles.tableWrapper, marginTop: "10px" }}>
                    <table style={styles.table}>
                        <thead style={styles.tableHeader}>
                            <tr>

                                {/* EMPLOYEE */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("employeeName")}>
                                    Employee{" "}
                                    {sortField === "employeeName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ORGANIZATION */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("organizationName")}>
                                    Organization{" "}
                                    {sortField === "organizationName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* CUSTOMER */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("customerName")}>
                                    Customer{" "}
                                    {sortField === "customerName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* CONTACT */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("contactNumber")}>
                                    Contact{" "}
                                    {sortField === "contactNumber"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* CALL TYPE */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("callType")}>
                                    Call Type{" "}
                                    {sortField === "callType"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* VALUE */}
                                <th style={{ ...styles.th, textAlign: "right", cursor: "pointer" }} onClick={() => handleSort("potentialValue")}>
                                    Value{" "}
                                    {sortField === "potentialValue"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* FOLLOW UP */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("nextFollowUpDate")}>
                                    Follow-up{" "}
                                    {sortField === "nextFollowUpDate"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>
                                <th style={styles.th}>Created On</th>
                                <th style={styles.th}>Updated On</th>
                                {/* STATUS */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("status")}>
                                    Status{" "}
                                    {sortField === "status"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ACTIONS */}
                                <th style={styles.th}>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedData.map((c, i) => (
                                <tr key={i}>
                                    {/*<td style={styles.td}>{highlightText(c.employeeName)}</td>*/}
                                    <td style={styles.td}>

                                        <div>

                                            <div>
                                                {highlightText(c.employeeName)}
                                            </div>

                                            <div style={{
                                                fontSize: "10px",
                                                color: "#666",
                                                marginTop: "2px"
                                            }}>
                                                {(c.empCode || "")} {"-> "} {c.branchName || ""}
                                            </div>

                                        </div>

                                    </td>
                                    <td style={styles.td}>{highlightText(c.organizationName)}</td>
                                    <td style={styles.td}>{highlightText(c.customerName)}</td>
                                    <td style={styles.td}>{highlightText(c.contactNumber)}</td>
                                    <td style={styles.td}>{highlightText(c.callType)}</td>

                                    {/* VALUE */}
                                    {/* VALUE */}
                                    <td style={{ ...styles.td, textAlign: "right" }}>
                                        {c.potentialValue !== null && c.potentialValue !== undefined
                                            ? highlightText(
                                                Number(c.potentialValue).toFixed(2)
                                            )
                                            : ""}
                                    </td>

                                    {/* DATE */}
                                    {/* DATE */}
                                    <td style={{ ...styles.td, textAlign: "left" }}>
                                        {c.nextFollowUpDate
                                            ? highlightText(
                                                new Date(c.nextFollowUpDate).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric"
                                                })
                                            )
                                            : ""}
                                    </td>
                                    <td style={styles.td}>
                                        <DateCell value={c.createdOn} />
                                    </td>

                                    <td style={styles.td}>
                                        <DateCell value={c.updatedOn} />
                                    </td>
                                    {/* STATUS */}
                                    <td style={{ ...styles.td, textAlign: "center" }}>
                                        <span
                                            style={{
                                                fontWeight: "bold",
                                                padding: "2px 8px",
                                                borderRadius: "10px",
                                                fontSize: "12px",
                                                color: "#fff",
                                                backgroundColor:
                                                    c.status === "Active" ? "#28a745" :
                                                    c.status === "Pending" ? "#ff9800" :
                                                    c.status === "Closed" ? "#6c757d" :
                                                    c.status === "Inactive" ? "#dc3545" :
                                                    "#999"
                                            }}
                                        >
                                            {c.status || "Active"}
                                        </span>
                                    </td>

                                    {/* ACTIONS */}
                                    <td style={{ ...styles.td, textAlign: "center" }}>
                                        <ActionButtons
                                            row={c}
                                            status={c.status}
                                            onEdit={handleEdit}
                                            onDelete={handleDelete}
                                            onPermanentDelete={handlePermanentDelete}
                                            onRestore={() => handleRestore(c)}
                                            canEdit={true}
                                            canDelete={true}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {filteredData.length === 0 && (
                            <tr>
                                <td colSpan="11" style={{ textAlign: "center", padding: "10px" }}>
                                    No records found
                                </td>
                            </tr>
                        )}
                    </table>
                </div>
                {/* 🔥 ADD THIS BLOCK RIGHT HERE */}
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "10px",
                    gap: "10px",
                    fontSize: "12px",
                    fontFamily: "Verdana"
                }}>

                <PaginationControls
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                />

                </div>
            </div>
        </div>   

);
}

const styles = {
    container: {
        padding: "5px",
        background: "#f1f2f6",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    header: {
        background: "#2f3542",
        color: "#fff",
        padding: "6px",
        borderRadius: "6px",
        marginBottom: "10px"
    },

    card: {
        background: "#fff",
        padding: "15px",
        borderRadius: "15px",
        marginBottom: "10px"
    },

    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "10px"
    },

    row: {
        display: "flex",
        gap: "10px"
    },

    buttonRow: {
        marginTop: "10px"
    },
    tableWrapper: {
        width: "100%",
        overflowX: "auto"
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed"   // 🔥 IMPORTANT (fix alignment)
    },

    tableHeader: {
        background: "#57606f",
        color: "#fff"
    },

    th: {
        border: "1px solid #ccc",
        padding: "8px",
        fontSize: "12px",
        textAlign: "left",
        whiteSpace: "nowrap"
    },

    td: {
        border: "1px solid #ddd",
        padding: "8px",
        fontSize: "12px",
        wordBreak: "break-word"
    },
    inputStyle: {
        "& .MuiOutlinedInput-root": {
            height: "34px"
        },

        "& .MuiInputBase-input": {
            fontFamily: "Verdana",
            fontSize: "12px",
            padding: "8px 10px"
        },

        "& .MuiInputLabel-root": {
            fontFamily: "Verdana",
            fontSize: "12px"
        },

        // 🔥 FIX DROPDOWN SPECIFIC
        "& .MuiSelect-select": {
            padding: "8px 10px !important",
            display: "flex",
            alignItems: "center"
        }
    }
};

export default DailyCall;